"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineTableField = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const form_context_1 = require("../../composite/form/form-context");
const table_field_1 = require("../table-field/table-field");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const inline_table_context_1 = require("./inline-table-context");
const inline_table_field_row_1 = require("./inline-table-field-row");
const inline_table_field_toolbar_1 = require("./inline-table-field-toolbar");
exports.InlineTableField = (0, react_1.forwardRef)(function InlineTableField({ ToolbarComponent = inline_table_field_toolbar_1.InlineTableFieldToolbar, RowComponent = inline_table_field_row_1.InlineTableFieldRow, showRadioCond = lodash_1.stubFalse, showDetailBtnCond = lodash_1.stubFalse, withRemove = true, initNewItem: providedInitNewItem, orderColumnPath = 'order', ...props }, ref) {
    var _a;
    const value = (_a = props.value) !== null && _a !== void 0 ? _a : [];
    const defaultInitNewItem = (0, event_callback_hook_1.useEventCallback)(() => {
        var _a;
        const object = {};
        if (props.useOrderColumn) {
            const lastOrder = (_a = (0, lodash_1.max)(value.map((item) => (0, lodash_1.get)(item, orderColumnPath)))) !== null && _a !== void 0 ? _a : 0;
            (0, lodash_1.set)(object, orderColumnPath, lastOrder + 1);
        }
        return object;
    });
    const initNewItem = providedInitNewItem !== null && providedInitNewItem !== void 0 ? providedInitNewItem : defaultInitNewItem;
    const context = (0, react_1.useMemo)(() => ({ withRemove, initNewItem, disabled: props.disabled }), [withRemove, initNewItem, props.disabled]);
    const { editing } = (0, react_1.useContext)(form_context_1.FormContext);
    /**
     * Hide actions if disabled, and both dndOrdering / removeButton not visible
     */
    const visibleActionsColumn = !props.disabled && (props.useDnDOrdering || (withRemove && editing));
    return (react_1.default.createElement(inline_table_context_1.InlineTableFieldContext.Provider, { value: context },
        react_1.default.createElement(table_field_1.TableField, { ToolbarComponent: ToolbarComponent, RowComponent: RowComponent, showRadioCond: showRadioCond, showDetailBtnCond: showDetailBtnCond, visibleActionsColumn: visibleActionsColumn, orderColumnPath: orderColumnPath, initNewItem: initNewItem, ...props, ref: ref })));
});
//# sourceMappingURL=inline-table-field.js.map